// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"l7M67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curvatureAtJunctionArcHandler", ()=>curvatureAtJunctionArcHandler);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _geom = require("ol/geom");
var _util = require("../../util");
var _curvatureArcGeometry = require("./curvatureArcGeometry");
var _curvatureArcScheduler = require("./curvatureArcScheduler");
// Per-source derivation state, keyed by the VectorSource. Never global — two CaJ
// layers can hold relations with the same Orbis id, and `clear` must reset only
// the cleared source. Replaces the old module-global `missingIds`.
const STATE = new WeakMap();
const dirtySources = new Set();
let rafHandle = null;
const FRAME_BUDGET_MS = 10;
// Read the from/to/via points + curvature for a relation, or report a missing
// member (the member feature hasn't arrived in this source yet). Pure read — no
// feature creation. Mirrors the original handler's extraction exactly, except
// member lookup is now O(1) via the prebuilt index instead of features.find().
function resolveArcInputs(relation, indexById) {
    const viaMember = (0, _util.getMembersWithRole)(relation, "via")[0];
    const alongFromMember = (0, _util.getMembersWithRole)(relation, "along_from_road")[0];
    const alongToMember = (0, _util.getMembersWithRole)(relation, "along_to_road")[0];
    if (!viaMember || !alongFromMember || !alongToMember) {
        console.error("member not found for feature", relation);
        return {
            status: "missing"
        };
    }
    const viaFeature = indexById.get(viaMember.id);
    const alongFromFeature = indexById.get(alongFromMember.id);
    const alongToFeature = indexById.get(alongToMember.id);
    if (!viaFeature || !alongFromFeature || !alongToFeature) return {
        status: "missing"
    };
    const curvature = Number((0, _util.getTags)(relation).find((tag)=>tag.tagKey.key === "curvature_at_junction").tagValue);
    const fromCoordinate = alongFromFeature.getGeometry().getCoordinateAt(alongFromMember.lrRange.start / alongFromFeature.get("lengthCm"));
    const toCoordinate = alongToFeature.getGeometry().getCoordinateAt(alongToMember.lrRange.start / alongToFeature.get("lengthCm"));
    const viaCoordinate = viaFeature.getGeometry().getCoordinates();
    return {
        status: "ready",
        from: {
            x: fromCoordinate[0],
            y: fromCoordinate[1]
        },
        to: {
            x: toCoordinate[0],
            y: toCoordinate[1]
        },
        via: {
            x: viaCoordinate[0],
            y: viaCoordinate[1]
        },
        curvature
    };
}
// Build the arc Feature. Preserves the original asymmetry: a real curve copies
// ALL relation properties (then overrides geometry); a straight/dummy arc does NOT.
function buildArcFeature(relation, arc, curvature) {
    let feature;
    if (arc.fromCurve) {
        feature = new (0, _featureDefault.default)({});
        feature.setProperties(relation.getProperties());
        feature.setGeometry(new (0, _geom.LineString)(arc.coordinates));
    } else feature = new (0, _featureDefault.default)({
        geometry: new (0, _geom.LineString)(arc.coordinates)
    });
    feature.set("type", arc.type);
    feature.set("relation-id", relation.getId());
    feature.set("curvature_at_junction", curvature);
    return feature;
}
function deriveArc(relation, indexById) {
    relation.set("is-relation", "yes"); // preserved as the original set it (output parity)
    const inputs = resolveArcInputs(relation, indexById);
    if (inputs.status === "missing") return {
        status: "missing"
    };
    const arc = (0, _curvatureArcGeometry.computeArcCoordinates)(inputs.from, inputs.to, inputs.via, inputs.curvature);
    return {
        status: "derived",
        feature: buildArcFeature(relation, arc, inputs.curvature)
    };
}
function ensureState(source) {
    let state = STATE.get(source);
    if (!state) {
        state = {
            derivedIds: new Set(),
            deferredIds: new Set()
        };
        STATE.set(source, state);
        // refresh() (revision/auth change) → clear() → reset state + drop from scheduler.
        source.on("clear", ()=>{
            state.derivedIds.clear();
            state.deferredIds.clear();
            dirtySources.delete(source);
        });
    }
    return state;
}
function ensureSchedulerRunning() {
    if (rafHandle === null) rafHandle = requestAnimationFrame(drainFrame);
}
function drainFrame() {
    rafHandle = null;
    const deadline = performance.now() + FRAME_BUDGET_MS;
    const now = ()=>performance.now();
    for (const source of dirtySources){
        const state = STATE.get(source);
        const { done } = (0, _curvatureArcScheduler.runDerivationPass)(source, state, {
            deriveArc,
            deadline,
            now
        });
        if (done) dirtySources.delete(source);
        if (performance.now() >= deadline) break;
    }
    if (dirtySources.size > 0) rafHandle = requestAnimationFrame(drainFrame);
}
const curvatureAtJunctionArcHandler = (event)=>{
    const source = event.target;
    const state = ensureState(source);
    state.deferredIds.clear();
    dirtySources.add(source);
    ensureSchedulerRunning();
};

},{"ol/Feature":"iVSSP","ol/geom":[["LineString","223qD","default"]],"../../util":"4IC9E","./curvatureArcGeometry":"c6MQ7","./curvatureArcScheduler":"4PbFD","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"c6MQ7":[function(require,module,exports,__globalThis) {
// Pure clothoid-arc geometry for curvature-at-junction relations.
// No OpenLayers / external imports — unit-tested with `node --test`.
// `buildCurveWithMinRadius` and `curveToCoordinates` are moved VERBATIM from
// the original CurvatureAtJunctionArcHandler.js; do not edit their bodies.
/**
 * Decide the arc geometry for one relation. Pure: takes plain {x,y} points.
 * Returns { type, coordinates: number[][], fromCurve }.
 *   fromCurve === true only when a real clothoid curve was fitted — the glue
 *   uses that flag to reproduce the original property-copy asymmetry.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeArcCoordinates", ()=>computeArcCoordinates);
function computeArcCoordinates(from, to, via, curvatureAtJunction) {
    let curve = null;
    if (curvatureAtJunction !== 0) {
        const radiusM = 10000 / Math.abs(curvatureAtJunction);
        curve = buildCurveWithMinRadius(from, to, via, radiusM);
    }
    if (curve === null) return {
        type: curvatureAtJunction === 0 ? "curvature-arc" : "curvature-arc-dummy",
        coordinates: [
            [
                from.x,
                from.y
            ],
            [
                to.x,
                to.y
            ]
        ],
        fromCurve: false
    };
    return {
        type: "curvature-arc",
        coordinates: curveToCoordinates(curve).map((p)=>[
                p.x,
                p.y
            ]),
        fromCurve: true
    };
}
// buildCurveWithMinRadius + curveToCoordinates below are moved VERBATIM from
// the original CurvatureAtJunctionArcHandler.js — do not edit (output parity).
/**
 * Build a composite curve (clothoid → circular arc → clothoid) between
 * pStart and pEnd, approaching pTarget, where curvature gradually increases
 * from zero to 1/minRadiusM, holds at that maximum curvature for a circular
 * arc section, then gradually decreases back to zero.
 *
 * The entry and exit clothoid angles are independent, allowing the circular
 * arc section to shift asymmetrically closer to pTarget when the approach
 * angles from pStart and pEnd differ.
 *
 * Returns an object with a .get(t) method compatible with Bezier.js,
 * or null if no valid curve can be constructed.
 */ function buildCurveWithMinRadius(pStart, pEnd, pTarget, minRadiusM) {
    function len(v) {
        return Math.hypot(v.x, v.y);
    }
    function unit(v) {
        const n = len(v);
        return n === 0 ? {
            x: 0,
            y: 0
        } : {
            x: v.x / n,
            y: v.y / n
        };
    }
    function sub(a, b) {
        return {
            x: a.x - b.x,
            y: a.y - b.y
        };
    }
    function mul(a, s) {
        return {
            x: a.x * s,
            y: a.y * s
        };
    }
    function dot(a, b) {
        return a.x * b.x + a.y * b.y;
    }
    function cross(a, b) {
        return a.x * b.y - a.y * b.x;
    }
    // Entry/exit directions (toward pTarget)
    const dirStart = unit(sub(pTarget, pStart));
    const dirEnd = unit(sub(pTarget, pEnd));
    // Determine the turning angle at the junction
    // The total angle swept is the angle between dirStart and the reverse of dirEnd
    // (since dirEnd points from pEnd toward pTarget, the exit tangent is -dirEnd)
    const exitDir = mul(dirEnd, -1); // tangent direction at pEnd (going away from pTarget)
    const totalTurnAngle = Math.atan2(cross(dirStart, exitDir), dot(dirStart, exitDir));
    // Determine turn direction: +1 = left (CCW), -1 = right (CW)
    const turnSign = totalTurnAngle >= 0 ? 1 : -1;
    const absTotalAngle = Math.abs(totalTurnAngle);
    if (absTotalAngle < 1e-6) // Essentially straight, no curve needed
    return null;
    const R = minRadiusM;
    // We split the curve into 3 sections with independent entry/exit angles:
    //   1. Entry clothoid:  curvature 0 → 1/R over angle α₁
    //   2. Circular arc:    curvature = 1/R over angle β
    //   3. Exit clothoid:   curvature 1/R → 0 over angle α₂
    // Constraint: α₁ + α₂ + β = absTotalAngle
    //
    // For a clothoid sweeping angle α, arc length L = 2·R·α
    //
    // We search over independent fractions f1, f2 ∈ (0, ~0.5)
    // where α₁ = f1 · absTotalAngle, α₂ = f2 · absTotalAngle,
    // β = (1 - f1 - f2) · absTotalAngle.
    // --- Helper functions for curve sections ---
    // Entry clothoid: curvature linearly increases from 0 to 1/R
    function clothoidPoints(startPos, startAngle, sign, alpha, radius, numPts) {
        const L = 2 * radius * alpha;
        const points = [];
        const steps = numPts - 1;
        let x = startPos.x;
        let y = startPos.y;
        let heading = startAngle;
        points.push({
            x,
            y
        });
        for(let i = 1; i <= steps; i++){
            const tPrev = (i - 1) / steps;
            const tCurr = i / steps;
            const ds = L * (tCurr - tPrev);
            // Curvature at midpoint: linearly from 0 to 1/R → κ(t) = t/R
            const tMid = (tPrev + tCurr) / 2;
            const curvature = sign * tMid / radius;
            heading += curvature * ds;
            x += Math.cos(heading) * ds;
            y += Math.sin(heading) * ds;
            points.push({
                x,
                y
            });
        }
        return {
            points,
            endPos: {
                x,
                y
            },
            endHeading: heading
        };
    }
    // Circular arc: constant curvature 1/R
    function arcPoints(startPos, startAngle, sign, arcAngle, radius, numPts) {
        const points = [];
        const curvature = sign / radius;
        const arcLength = Math.abs(arcAngle) * radius;
        const steps = numPts - 1;
        let x = startPos.x;
        let y = startPos.y;
        let heading = startAngle;
        points.push({
            x,
            y
        });
        for(let i = 1; i <= steps; i++){
            const ds = arcLength / steps;
            heading += curvature * ds;
            x += Math.cos(heading) * ds;
            y += Math.sin(heading) * ds;
            points.push({
                x,
                y
            });
        }
        return {
            points,
            endPos: {
                x,
                y
            },
            endHeading: heading
        };
    }
    // Exit clothoid: curvature linearly decreases from 1/R to 0
    function clothoidPointsReverse(startPos, startAngle, sign, alpha, radius, numPts) {
        const L = 2 * radius * alpha;
        const points = [];
        const steps = numPts - 1;
        let x = startPos.x;
        let y = startPos.y;
        let heading = startAngle;
        points.push({
            x,
            y
        });
        for(let i = 1; i <= steps; i++){
            const tPrev = (i - 1) / steps;
            const tCurr = i / steps;
            const ds = L * (tCurr - tPrev);
            // Curvature at midpoint: linearly from 1/R to 0 → κ(t) = (1-t)/R
            const tMid = (tPrev + tCurr) / 2;
            const curvature = sign * (1 - tMid) / radius;
            heading += curvature * ds;
            x += Math.cos(heading) * ds;
            y += Math.sin(heading) * ds;
            points.push({
                x,
                y
            });
        }
        return {
            points,
            endPos: {
                x,
                y
            },
            endHeading: heading
        };
    }
    // --- Geometry helpers for intersection / inner-side checks ---
    // Determine the "inner side" sign for a point relative to a directed segment.
    // The inner side of the turn pStart→pTarget→pEnd is the side where the curve
    // should be. We compute which side of each segment the curve should stay on.
    // Returns: for segment A→B, the sign of cross(B-A, P-A) that a point P on
    // the inner side should have.
    const innerSignSeg1 = Math.sign(cross(sub(pTarget, pStart), sub(pEnd, pStart)));
    // For segment pTarget→pEnd, use pStart as the inner-side reference
    const innerSignSeg2 = Math.sign(cross(sub(pEnd, pTarget), sub(pStart, pTarget)));
    // Check if a point is on the inner side (or on) segment pStart→pTarget
    function isInnerSideSeg1(p) {
        const s = cross(sub(pTarget, pStart), sub(p, pStart));
        return innerSignSeg1 === 0 || Math.sign(s) === innerSignSeg1 || Math.abs(s) < 1e-20;
    }
    // Check if a point is on the inner side (or on) segment pTarget→pEnd
    function isInnerSideSeg2(p) {
        const s = cross(sub(pEnd, pTarget), sub(p, pTarget));
        return innerSignSeg2 === 0 || Math.sign(s) === innerSignSeg2 || Math.abs(s) < 1e-20;
    }
    // Count how many segments of the curve polyline intersect the boundary
    // segments pStart→pTarget and pTarget→pEnd, and how many interior points
    // lie on the outer side of the turn.
    // Returns { intersectionCount: number, outerCount: number }
    function checkCurveAgainstBoundary(fittedPoints) {
        let outerCount = 0;
        // Count how many interior points are on the outer side
        for(let i = 1; i < fittedPoints.length - 1; i++){
            const p = fittedPoints[i];
            if (!isInnerSideSeg1(p) || !isInnerSideSeg2(p)) outerCount++;
        }
        return outerCount;
    }
    const startHeading = Math.atan2(dirStart.y, dirStart.x);
    let bestCurve = null;
    let bestScore = Infinity;
    const gridSteps = 20; // grid resolution for f1 and f2
    const ptsPerSection = 40;
    // Search over independent entry/exit clothoid fractions
    for(let i1 = 1; i1 <= gridSteps; i1++){
        const f1 = i1 / (gridSteps * 2); // f1 from 0.025 to 0.50
        for(let i2 = 1; i2 <= gridSteps; i2++){
            const f2 = i2 / (gridSteps * 2); // f2 from 0.025 to 0.50
            // Circular arc fraction must be non-negative
            // There should be a minimal circular angle
            if (f1 + f2 >= 1) continue;
            // There should be a minimal entry and exit
            // if (f1 < 0.1) continue;
            // if (f2 < 0.1) continue;
            const alphaEntry = f1 * absTotalAngle;
            const alphaExit = f2 * absTotalAngle;
            const beta = (1 - f1 - f2) * absTotalAngle;
            // Iteratively compensate the construction radius so that after the
            // scale+rotate fit the actual arc-section radius equals the target R.
            // We start with Rcomp = R, build the curve, compute the scale factor,
            // then set Rcomp = R / scale and repeat until convergence.
            let Rcomp = R;
            let allPoints = null;
            let scale = 1;
            let rotAngle = 0;
            const maxIter = 5;
            const desDx = pEnd.x - pStart.x;
            const desDy = pEnd.y - pStart.y;
            const desLen = Math.hypot(desDx, desDy);
            const desAngle = Math.atan2(desDy, desDx);
            let valid = true;
            for(let iter = 0; iter < maxIter; iter++){
                // Build entry clothoid (curvature 0 → 1/Rcomp)
                const entry = clothoidPoints(pStart, startHeading, turnSign, alphaEntry, Rcomp, ptsPerSection);
                // Build circular arc (curvature = 1/Rcomp)
                const arc = arcPoints(entry.endPos, entry.endHeading, turnSign, beta, Rcomp, ptsPerSection);
                // Build exit clothoid (curvature 1/Rcomp → 0)
                const exit = clothoidPointsReverse(arc.endPos, arc.endHeading, turnSign, alphaExit, Rcomp, ptsPerSection);
                // Collect all points
                allPoints = [
                    ...entry.points,
                    ...arc.points.slice(1),
                    ...exit.points.slice(1)
                ];
                const rawStart = allPoints[0];
                const rawEnd = allPoints[allPoints.length - 1];
                const rawDx = rawEnd.x - rawStart.x;
                const rawDy = rawEnd.y - rawStart.y;
                const rawLen = Math.hypot(rawDx, rawDy);
                if (rawLen < 1e-12) {
                    valid = false;
                    break;
                }
                const rawAngle = Math.atan2(rawDy, rawDx);
                scale = desLen / rawLen;
                rotAngle = desAngle - rawAngle;
                // Compensate: we want the fitted radius to be R,
                // so the construction radius should be R / scale.
                const newRcomp = R / scale;
                if (Math.abs(newRcomp - Rcomp) / R < 1e-6) break; // converged
                Rcomp = newRcomp;
            }
            if (!valid || !allPoints) continue;
            // Simulate the scale+rotate fitting to evaluate against actual geometry
            const cosRot = Math.cos(rotAngle);
            const sinRot = Math.sin(rotAngle);
            const rawStart = allPoints[0];
            // Transform all points to fitted positions
            const fittedPoints = allPoints.map((p)=>{
                const dx = (p.x - rawStart.x) * scale;
                const dy = (p.y - rawStart.y) * scale;
                return {
                    x: pStart.x + dx * cosRot - dy * sinRot,
                    y: pStart.y + dx * sinRot + dy * cosRot
                };
            });
            // Check intersection and inner-side constraints
            const outerCount = checkCurveAgainstBoundary(fittedPoints);
            // Find the closest distance to pTarget after fitting
            let minDistToTarget = Infinity;
            for (const p of fittedPoints){
                const d = Math.hypot(p.x - pTarget.x, p.y - pTarget.y);
                if (d < minDistToTarget) minDistToTarget = d;
            }
            // Penalty-based scoring: outer-side points
            // are bad, and distance to pTarget is the tiebreaker.
            const outerPenalty = outerCount * 1e6;
            const score = minDistToTarget + outerPenalty;
            if (score < bestScore) {
                bestScore = score;
                bestCurve = allPoints;
            }
        }
    }
    // Apply scale + rotate transform to exactly match pStart → pEnd
    if (bestCurve && bestCurve.length > 2) {
        const rawStart = bestCurve[0];
        const rawEnd = bestCurve[bestCurve.length - 1];
        const rawDx = rawEnd.x - rawStart.x;
        const rawDy = rawEnd.y - rawStart.y;
        const rawLen = Math.hypot(rawDx, rawDy);
        const rawAngle = Math.atan2(rawDy, rawDx);
        const desDx = pEnd.x - pStart.x;
        const desDy = pEnd.y - pStart.y;
        const desLen = Math.hypot(desDx, desDy);
        const desAngle = Math.atan2(desDy, desDx);
        if (rawLen < 1e-12) return null;
        const scale = desLen / rawLen;
        const rotAngle = desAngle - rawAngle;
        const cosRot = Math.cos(rotAngle);
        const sinRot = Math.sin(rotAngle);
        const fitted = bestCurve.map((p)=>{
            let dx = (p.x - rawStart.x) * scale;
            let dy = (p.y - rawStart.y) * scale;
            return {
                x: pStart.x + dx * cosRot - dy * sinRot,
                y: pStart.y + dx * sinRot + dy * cosRot
            };
        });
        // Return a curve-like object with .get(t) for compatibility
        return {
            _points: fitted,
            get (t) {
                const clampedT = Math.max(0, Math.min(1, t));
                const idx = clampedT * (this._points.length - 1);
                const lo = Math.floor(idx);
                const hi = Math.min(lo + 1, this._points.length - 1);
                const frac = idx - lo;
                return {
                    x: this._points[lo].x + frac * (this._points[hi].x - this._points[lo].x),
                    y: this._points[lo].y + frac * (this._points[hi].y - this._points[lo].y)
                };
            }
        };
    }
    return null;
}
function curveToCoordinates(curve, samples = 100) {
    return Array.from(Array(samples).keys()).map((index)=>curve.get(index / samples));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4PbFD":[function(require,module,exports,__globalThis) {
// Pure scheduler bookkeeping for curvature-at-junction arc derivation.
// No OpenLayers / external imports — unit-tested with `node --test`.
//
// State per source: { derivedIds: Set, deferredIds: Set }
//   derivedIds  — relations already turned into an arc (committed). Never redone.
//   deferredIds — relations seen but missing >=1 member. Parked: NOT retried every
//                 frame; only re-armed (cleared) by the next featuresloadend / clear.
// Mirrors getTags()'s key parsing without importing it (keeps this module dep-free):
// a property named "<digits>-curvature_at_junction" means the relation carries the tag.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectCandidates", ()=>selectCandidates);
parcelHelpers.export(exports, "buildIndex", ()=>buildIndex);
/**
 * Process the source's outstanding candidates, time-sliced.
 *   deriveArc(relation, indexById) -> { status:"derived", feature } | { status:"missing" }
 *   deadline / now() — pacing; the deadline is checked BETWEEN relations.
 * Each candidate is resolved exactly once: committed (derivedIds) or parked
 * (deferredIds). Returns { done } — true when this pass exhausted its candidate
 * snapshot (all were processed before the deadline), false when the deadline
 * fired mid-pass (the remaining candidates will be picked up on the next pass).
 */ parcelHelpers.export(exports, "runDerivationPass", ()=>runDerivationPass);
function hasCurvatureAtJunctionTag(feature) {
    const props = feature.getProperties();
    return Object.keys(props).some((p)=>{
        const m = p.match(/^(\d+)-(.+)$/);
        return m && m[2] === "curvature_at_junction";
    });
}
function selectCandidates(features, derivedIds, deferredIds) {
    return features.filter((f)=>{
        if (f.get("type") !== "ORBIS_RELATION") return false;
        const id = f.getId();
        if (derivedIds.has(id) || deferredIds.has(id)) return false;
        return hasCurvatureAtJunctionTag(f);
    });
}
function buildIndex(features) {
    const map = new Map();
    for (const f of features){
        const id = f.getId();
        if (id !== undefined) map.set(id, f);
    }
    return map;
}
function runDerivationPass(source, state, { deriveArc, deadline, now }) {
    const features = source.getFeatures();
    const indexById = buildIndex(features);
    const candidates = selectCandidates(features, state.derivedIds, state.deferredIds);
    for(let i = 0; i < candidates.length; i++){
        const relation = candidates[i];
        const result = deriveArc(relation, indexById);
        if (result.status === "derived") {
            source.addFeature(result.feature);
            state.derivedIds.add(relation.getId());
        } else state.deferredIds.add(relation.getId());
        if (now() >= deadline) return {
            done: i === candidates.length - 1
        };
    }
    return {
        done: true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dIuFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCaJStyleNormalOrbisSD", ()=>getCaJStyleNormalOrbisSD);
parcelHelpers.export(exports, "getCaJStyleClickOrbisSD", ()=>getCaJStyleClickOrbisSD);
parcelHelpers.export(exports, "getCaJStyleHoverOrbisSD", ()=>getCaJStyleHoverOrbisSD);
var _style = require("ol/style");
var _colorScale = require("./util/colorScale");
var _util = require("../../util");
function getCaJStyleNormalOrbisSD(feature) {
    return getCaJColorStyle(feature, false, false);
}
function getCaJStyleClickOrbisSD(feature) {
    return getCaJColorStyle(feature, true, false);
}
function getCaJStyleHoverOrbisSD(feature) {
    return getCaJColorStyle(feature, false, true);
}
function getCaJColorStyle(feature, click, hover) {
    let width, backgroundColor, backgroundWidth;
    const type = feature.get("type");
    if (type !== "curvature-arc" && type !== "curvature-arc-dummy") return new (0, _style.Style)({});
    const curvature = Number(feature.get("curvature_at_junction"));
    const speed = isNaN(curvature) ? 0 : (0, _util.maxSpeedFromCurvature)(curvature);
    const [r, g, b] = (0, _colorScale.colorForSpeed)(speed);
    const color = `rgb(${r},${g},${b})`;
    if (hover || click) {
        width = 7;
        backgroundWidth = 10;
    } else {
        width = 5;
        backgroundWidth = 9;
    }
    backgroundColor = "white";
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./util/colorScale":"dOPOB","../../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},[], null, "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.fc85953d.js.map
